import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MarkdownModule } from 'ngx-markdown';

import Utils from '@constants/utils';
import { AlertDialogData } from './alert-dialog.interface';

@Component({
  selector: 'app-alert-dialog',
  standalone: true,
  imports: [MatDialogModule, MarkdownModule],
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent {
  pageId: string;
  alert: AlertDialogData;
  ids: string;

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog
  ) {
    this.alert = {
      pageName: data.pageName,
      title: data.title,
      message: data.message,
      buttonText: data.buttonText
    };
  }

  ngOnInit(): void {
    this.ids = Utils.toUpperCamelCase(this.alert?.buttonText, ' ');
  }

  // Close the dialog
  target(): void {
    this.dialogRef.close();
  }
}
